document.addEventListener('DOMContentLoaded', function () {
  var PENDING_EMAIL_KEY = 'riverslide_pending_email';

  // Shopify's form.email in Liquid isn't reliably populated after a
  // successful submission, only when there's a validation error to
  // redisplay. So capture the typed email ourselves right before the
  // form submits and carry it across the redirect via sessionStorage.
  document.querySelectorAll('input[name="contact[email]"]').forEach(function (input) {
    var form = input.closest('form');
    if (!form) return;
    form.addEventListener('submit', function () {
      if (input.value) {
        sessionStorage.setItem(PENDING_EMAIL_KEY, input.value.trim());
      }
    });
  });

  var faces = {
    1: [5],
    2: [1, 9],
    3: [1, 5, 9],
    4: [1, 3, 7, 9],
    5: [1, 3, 5, 7, 9],
    6: [1, 3, 4, 6, 7, 9]
  };

  var ROLLED_FLAG = 'riverslide_dice_rolled';

  function setFace(dieEl, value) {
    if (!dieEl) return;
    var pips = dieEl.querySelectorAll('.dice-signup__pip');
    pips.forEach(function (p) { p.classList.remove('is-on'); });
    faces[value].forEach(function (pos) {
      var pip = dieEl.querySelector('[data-pos="' + pos + '"]');
      if (pip) pip.classList.add('is-on');
    });
  }

  function randomFace() {
    return Math.floor(Math.random() * 6) + 1;
  }

  function trackRollToKlaviyo(email, tier, isJackpot) {
    if (!window.klaviyo || !email) return;

    window.klaviyo.push(['identify', { email: email }]);
    window.klaviyo.push(['track', 'Rolled Discount Dice', {
      Result: isJackpot ? 'Double Six' : 'Standard',
      DiscountTier: tier
    }]);
  }

  document.querySelectorAll('.dice-signup').forEach(function (block) {
    var customerEmail = block.dataset.customerEmail || sessionStorage.getItem(PENDING_EMAIL_KEY) || '';
    var standardTier = block.dataset.standardTier || '10';
    var jackpotTier = block.dataset.jackpotTier || '20';

    var die1 = block.querySelector('[id^="DiceOne-"]');
    var die2 = block.querySelector('[id^="DiceTwo-"]');
    var rollBtn = block.querySelector('[id^="DiceRollButton-"]');
    var reveal = block.querySelector('[id^="DiceReveal-"]');

    if (!rollBtn) return;

    setFace(die1, 3);
    setFace(die2, 4);

    // If they've already rolled in this browser, don't let them roll or
    // fire a second tracking event, just show the same confirmation text.
    if (localStorage.getItem(ROLLED_FLAG) === '1') {
      rollBtn.disabled = true;
      rollBtn.textContent = 'Already rolled';
      reveal.classList.add('is-visible');
      return;
    }

    rollBtn.addEventListener('click', function () {
      rollBtn.disabled = true;
      rollBtn.textContent = 'Rolling...';

      die1.classList.add('is-rolling');
      die2.classList.add('is-rolling');

      var tumbleInterval = setInterval(function () {
        setFace(die1, randomFace());
        setFace(die2, randomFace());
      }, 90);

      setTimeout(function () {
        clearInterval(tumbleInterval);
        die1.classList.remove('is-rolling');
        die2.classList.remove('is-rolling');

        var roll1 = randomFace();
        var roll2 = randomFace();
        setFace(die1, roll1);
        setFace(die2, roll2);

        var isJackpot = roll1 === 6 && roll2 === 6;
        var tier = isJackpot ? jackpotTier : standardTier;

        localStorage.setItem(ROLLED_FLAG, '1');

        trackRollToKlaviyo(customerEmail, tier, isJackpot);
        sessionStorage.removeItem(PENDING_EMAIL_KEY);

        rollBtn.textContent = 'Rolled';
        reveal.classList.add('is-visible');
      }, 1400);
    });
  });
});
